__turbopack_context__.v({
  "availabilityIcon": "StoreAvailability-module-scss-module__DNnigW__availabilityIcon",
  "availabilityText": "StoreAvailability-module-scss-module__DNnigW__availabilityText",
  "quantityTextInStock": "StoreAvailability-module-scss-module__DNnigW__quantityTextInStock",
  "quantityTextLowStock": "StoreAvailability-module-scss-module__DNnigW__quantityTextLowStock",
  "stockMessage": "StoreAvailability-module-scss-module__DNnigW__stockMessage",
  "wrapper": "StoreAvailability-module-scss-module__DNnigW__wrapper",
});
